import { REQUIRED } from "@/util/validation-rules"
import { isDateFuture } from "@/util"
import { DATE_DEFAULT_REGXP } from "@/util/const"

export default class CMCourseValidator {
  constructor(data, validator) {
    this.data = data
    this.validator = validator
  }
  
  validate () {
    this.validator.resetFields()
    return this.isValid()
  }

  isValid() {
    this.validateDateName()
    // this.validateDate()
    this.validateCity()
    this.validateVisibleOnLandingField()
    // this.validateRequired('name', this.data.name)
    return this.validator.isValid()
  }

  validateVisibleOnLandingField() {
    if (this.data.isVisibleOnLanding === null) {
      this.validator.invalidField('isVisibleOnLanding', 'Visibility on landing should be chosen')
    }
  }

  validateDateName() {
    if(!this.data.date && !this.data.name) {
      this.validator.invalidField('date', 'Date or Name should be filled')
      this.validator.invalidField('name', 'Date or Name should be filled')
      return
    }
    if(this.data.date) this.validateDate()
  }

  validateDate() {
    if(!(DATE_DEFAULT_REGXP.test(this.data.date))) 
      this.validator.invalidField(
        'date', 
        'Date should be in DD-MM-YYYY format'
      )
  }

  validateRequired(field, data) {
    let match = REQUIRED(data)
    if(match === true) return true
    this.validator.invalidField(field, match)
    return false
  }

  validateNotes() {
    if(!this.validateRequired('notes', this.data.notes)) return
  }

  validateCity() {
    if(!this.validateRequired('city', this.data.city)) return
  }
}